import { defineComponent as R, mergeModels as B, useModel as S, useTemplateRef as V, watch as F, computed as m, useId as z, onMounted as D, onBeforeUnmount as U, createElementBlock as g, openBlock as l, Fragment as q, createVNode as f, unref as o, withCtx as s, renderSlot as p, mergeProps as j, createElementVNode as c, normalizeClass as u, createBlock as W, createCommentVNode as v, withModifiers as G } from "vue";
import n from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Popover/popover.js";
import { useHtmlElementFromVNodes as J } from "../use/index.js";
import P from "../_virtual/c_popover_MaxWidth.js";
import E from "../_virtual/c_popover_MinWidth.js";
import K from "../helpers/FocusTrap.vue2.js";
import Q from "./CloseButton.vue2.js";
import X from "./Title.vue2.js";
import Y from "../helpers/FloatingUi.vue2.js";
import Z from "../helpers/PassThrough.vue2.js";
import { flip as _, autoPlacement as x, offset as ee, hide as M } from "../node_modules/.pnpm/@floating-ui_core@1.6.9/node_modules/@floating-ui/core/dist/floating-ui.core.js";
import { useOUIAProps as oe } from "../helpers/ouia.js";
const ae = ["id"], te = ["id"], ye = /* @__PURE__ */ R({
  name: "PfPopover",
  inheritAttrs: !1,
  __name: "Popover",
  props: /* @__PURE__ */ B({
    focusTrap: { type: Boolean },
    appendTo: {},
    autoWidth: { type: Boolean },
    noPadding: { type: Boolean },
    showClose: { type: Boolean },
    flip: { type: Boolean },
    flipOptions: {},
    placementOptions: {},
    noHideOnOutsideClick: { type: Boolean },
    position: { default: "top" },
    minWidth: { default: E.value },
    maxWidth: { default: P.value },
    animationDuration: { default: 300 },
    closeBtnAriaLabel: { default: "Close" },
    distance: { default: 25 },
    ariaLabel: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ B(["shown", "hidden"], ["update:open"]),
  setup(h, { expose: L }) {
    const i = h, O = oe({ id: i.ouiaId, safe: i.ouiaSafe }), t = S(h, "open"), A = V("dialogRef"), { element: y, findReference: H } = J();
    F(y, (e) => {
      e == null || e.addEventListener("click", (a) => {
        a.stopPropagation(), t.value = !t.value;
      });
    });
    const I = m(() => [
      i.flip ? _(i.flipOptions) : x(i.placementOptions),
      ee(i.distance),
      M(),
      M({
        strategy: "escaped"
      })
    ]), r = z(), T = m(() => i.minWidth !== E.value), N = m(() => i.maxWidth !== P.value);
    D(() => {
      document.addEventListener("click", $), document.addEventListener("keydown", b, { capture: !0 });
    }), U(() => {
      document.removeEventListener("click", $), document.removeEventListener("keydown", b, { capture: !0 });
    });
    function $(e) {
      var a, d;
      i.noHideOnOutsideClick || !t.value || (d = (a = A.value) == null ? void 0 : a.$el) != null && d.contains(e.target) || (t.value = !1);
    }
    function b(e) {
      const a = e.keyCode || e.which;
      !t.value || a !== 27 || (t.value = !1);
    }
    return L({
      visible: t
    }), (e, a) => (l(), g(q, null, [
      f(Z, { onChildren: o(H) }, {
        default: s(() => [
          p(e.$slots, "default")
        ]),
        _: 3
      }, 8, ["onChildren"]),
      f(Y, {
        "teleport-to": e.appendTo,
        reference: o(y),
        placement: e.position,
        middleware: I.value,
        hidden: !t.value,
        "animation-duration": e.animationDuration,
        onShown: a[1] || (a[1] = () => e.$emit("shown")),
        onHidden: a[2] || (a[2] = () => e.$emit("hidden"))
      }, {
        default: s(({ placement: d, middlewareData: C }) => {
          var k, w;
          return [
            f(K, j({ ref: "dialogRef" }, { ...o(O), ...e.$attrs }, {
              active: e.focusTrap && t.value,
              class: [o(n).popover, o(n).modifiers[d], {
                [o(n).modifiers.noPadding]: e.noPadding,
                [o(n).modifiers.widthAuto]: e.autoWidth
              }],
              role: "dialog",
              "aria-modal": "true",
              "aria-label": e.$slots.header ? void 0 : e.ariaLabel,
              "aria-labelledby": e.$slots.header ? `popover-${o(r)}-header` : void 0,
              "aria-describedby": `popover-${o(r)}-body`,
              style: {
                minWidth: T.value ? e.minWidth : void 0,
                maxWidth: N.value ? e.maxWidth : void 0
              },
              "data-popper-reference-hidden": (k = C.hide) == null ? void 0 : k.referenceHidden,
              "data-popper-escaped": (w = C.hide) == null ? void 0 : w.escaped,
              "data-popper-placement": d
            }), {
              default: s(() => [
                c("div", {
                  class: u(o(n).popoverArrow)
                }, null, 2),
                c("div", {
                  class: u(o(n).popoverContent)
                }, [
                  e.showClose ? (l(), W(Q, {
                    key: 0,
                    "aria-label": e.closeBtnAriaLabel,
                    onClick: a[0] || (a[0] = G((ie) => t.value = !1, ["prevent"]))
                  }, null, 8, ["aria-label"])) : v("", !0),
                  e.$slots.header ? (l(), W(X, {
                    key: 1,
                    id: `popover-${o(r)}-header`,
                    h: 6,
                    size: "md"
                  }, {
                    default: s(() => [
                      p(e.$slots, "header")
                    ]),
                    _: 3
                  }, 8, ["id"])) : v("", !0),
                  c("div", {
                    id: `popover-${o(r)}-body`,
                    class: u(o(n).popoverBody)
                  }, [
                    p(e.$slots, "body")
                  ], 10, ae),
                  e.$slots.footer ? (l(), g("footer", {
                    key: 2,
                    id: `popover-${o(r)}-footer`,
                    class: u(o(n).popoverFooter)
                  }, [
                    p(e.$slots, "footer")
                  ], 10, te)) : v("", !0)
                ], 2)
              ]),
              _: 2
            }, 1040, ["active", "class", "aria-label", "aria-labelledby", "aria-describedby", "style", "data-popper-reference-hidden", "data-popper-escaped", "data-popper-placement"])
          ];
        }),
        _: 3
      }, 8, ["teleport-to", "reference", "placement", "middleware", "hidden", "animation-duration"])
    ], 64));
  }
});
export {
  ye as default
};
